import React from 'react';
import {
  Field,
  ImageField,
  LinkFieldValue,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { ResponsiveImage, ResponsiveImageProps } from '../ResponsiveImage/ResponsiveImage';

type UnifiedHeaderLogoFields = {
  'Logo Image': ImageField;
  'Mobile Logo Image': ImageField;
  Link: Field<LinkFieldValue>;
  Direction: Field<string>;
};

type UnifiedHeaderLogoOwnProps = {
  fields?: UnifiedHeaderLogoFields;
  params?: Record<string, string>;
};

type UnifiedHeaderLogoProps = UnifiedHeaderLogoOwnProps & WithSitecoreContextProps;

const UnifiedHeaderLogo: React.FC<UnifiedHeaderLogoProps> = ({ fields, sitecoreContext }) => {
  if (fields) {
    const imageObj: ResponsiveImageProps = {
      responsiveFields: {
        MobileImageSrc: fields['Mobile Logo Image'],
        DesktopImageSrc: fields['Logo Image'],
      },
      sitecoreContext: sitecoreContext as any,
    };

    return (
      <div className="unifiedHeaderLogo">
        <a
          href={fields.Link?.value?.href}
          target={fields.Link?.value?.target}
          title={fields.Link?.value?.title}
        >
          <ResponsiveImage
            responsiveFields={imageObj.responsiveFields}
            sitecoreContext={imageObj.sitecoreContext}
          />
        </a>
      </div>
    );
  } else if (!fields && sitecoreContext?.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }

  return <></>;
};

export default withSitecoreContext()(UnifiedHeaderLogo as any);
